/** Add a role by hand. Publishing a sport usually creates them for you. */

import { Crumbs, PageHead, Problem } from "@/components/kit";
import { RoleForm } from "@/components/RoleForm";
import { listDefinitions } from "@/lib/api/client";
import { useApi } from "@/spa/useApi";

/** Only published sports: a role names a sport the engine already enforces. */
export function publishedSports(defs: Awaited<ReturnType<typeof listDefinitions>>): string[] {
  return [...new Set(defs.filter((d) => d.status === "PUBLISHED").map((d) => d.sportCode))];
}

export function NewRolePage() {
  const { data: sports, loading, error } = useApi(
    () => listDefinitions().then(publishedSports),
    [],
    "failed to load",
  );

  if (error) return <Problem>Could not reach the admin service: {error}</Problem>;
  if (!sports) return <PageHead title="New role" note={loading ? "Loading…" : ""} />;

  return (
    <>
      <Crumbs trail={[{ label: "Roles", href: "/roles" }, { label: "New" }]} />
      <RoleForm sports={sports} />
    </>
  );
}
